(function () {
  'use strict';

  const SUPABASE_URL = 'https://xoolcbbpnvdylcoorlqg.supabase.co';
  const PUBLISHABLE_KEY = 'sb_publishable_bjOrV5qp2n0PtuVFOSA_6g_3Micws2T';

  function getSession() {
    try {
      const key = Object.keys(localStorage).find(
        (k) => k.includes('sb-') && k.endsWith('-auth-token')
      );

      if (!key) return null;

      return JSON.parse(localStorage.getItem(key));
    } catch (error) {
      console.error('[Corevian Admin Approve] Session error:', error);
      return null;
    }
  }

  function getAccessToken() {
    return getSession()?.access_token || null;
  }

  async function rpc(functionName, payload = {}) {
    const accessToken = getAccessToken();

    if (!accessToken) {
      throw new Error('No active Corevian University session was found.');
    }

    const response = await fetch(
      `${SUPABASE_URL}/rest/v1/rpc/${functionName}`,
      {
        method: 'POST',
        headers: {
          apikey: PUBLISHABLE_KEY,
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      }
    );

    const text = await response.text();

    let body = null;

    try {
      body = text ? JSON.parse(text) : null;
    } catch {
      body = text;
    }

    if (!response.ok) {
      throw new Error(
        body?.message ||
        body?.details ||
        body?.error ||
        `Request failed with status ${response.status}`
      );
    }

    return body;
  }

  async function restGet(path) {
    const accessToken = getAccessToken();

    if (!accessToken) {
      throw new Error('No active Corevian University session was found.');
    }

    const response = await fetch(`${SUPABASE_URL}/rest/v1/${path}`, {
      method: 'GET',
      headers: {
        apikey: PUBLISHABLE_KEY,
        Authorization: `Bearer ${accessToken}`
      }
    });

    const text = await response.text();

    let body = null;

    try {
      body = text ? JSON.parse(text) : null;
    } catch {
      body = text;
    }

    if (!response.ok) {
      throw new Error(
        body?.message ||
        body?.details ||
        body?.error ||
        `Request failed with status ${response.status}`
      );
    }

    return body;
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  async function resolveVersionId(row) {
    const directId =
      row.document_version_id ||
      row.version_id ||
      row.controlled_document_version_id;

    if (directId) return directId;

    const documentCode = row.document_code;
    const versionNumber = row.version_number;

    if (!documentCode || !versionNumber) {
      throw new Error(
        'Unable to identify this document version. Document code or version number is missing.'
      );
    }

    const documents = await restGet(
      `controlled_documents?select=id&document_code=eq.${encodeURIComponent(documentCode)}&limit=1`
    );

    if (!Array.isArray(documents) || !documents.length) {
      throw new Error(`Document ${documentCode} could not be found.`);
    }

    const documentId = documents[0].id;

    const versions = await restGet(
      `controlled_document_versions?select=id&document_id=eq.${encodeURIComponent(documentId)}&version_number=eq.${encodeURIComponent(versionNumber)}&limit=1`
    );

    if (!Array.isArray(versions) || !versions.length) {
      throw new Error(
        `Version ${versionNumber} for ${documentCode} could not be found.`
      );
    }

    return versions[0].id;
  }

  function injectStyles() {
    if (document.getElementById('cvnAdminApproveStyles')) return;

    const style = document.createElement('style');
    style.id = 'cvnAdminApproveStyles';

    style.textContent = `
      #cvnApproveLauncher {
        appearance: none;
        border: 1px solid #536178;
        background: #17243a;
        color: #ffffff;
        font-weight: 700;
        padding: 10px 16px;
        border-radius: 8px;
        cursor: pointer;
        margin-left: 10px;
      }

      #cvnApproveLauncher:hover {
        border-color: #19B5B0;
      }

      #cvnApproveOverlay {
        position: fixed;
        inset: 0;
        z-index: 12200;
        background: rgba(3, 8, 18, .80);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
      }

      #cvnApprovePanel {
        width: min(700px, 96vw);
        max-height: 90vh;
        overflow-y: auto;
        background: #0B1426;
        color: #ffffff;
        border: 1px solid rgba(25,181,176,.35);
        border-radius: 16px;
        padding: 26px;
        box-shadow: 0 24px 70px rgba(0,0,0,.45);
      }

      #cvnApprovePanel h2 {
        margin: 0 0 7px;
        font-size: 25px;
        color: #ffffff !important;
      }

      .cvn-approve-subtitle {
        color: #aab6c9;
        line-height: 1.5;
        margin-bottom: 22px;
      }

      #cvnApproveMessage {
        display: none;
        margin-bottom: 16px;
        padding: 11px 13px;
        border-radius: 8px;
      }

      #cvnApproveMessage.success {
        display: block;
        background: rgba(25,181,176,.14);
        border: 1px solid rgba(25,181,176,.45);
        color: #cffffb;
      }

      #cvnApproveMessage.error {
        display: block;
        background: rgba(190,65,65,.13);
        border: 1px solid rgba(210,80,80,.45);
        color: #ffd2d2;
      }

      .cvn-approve-field {
        margin-bottom: 18px;
      }

      .cvn-approve-field label {
        display: block;
        font-size: 13px;
        font-weight: 700;
        color: #d7e0ec;
        margin-bottom: 7px;
      }

      .cvn-approve-field select,
      .cvn-approve-field input {
        width: 100%;
        box-sizing: border-box;
        border: 1px solid #31415a;
        background: #111d31;
        color: #ffffff;
        border-radius: 8px;
        padding: 12px;
        font: inherit;
      }

      .cvn-approve-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
      }

      .cvn-approve-notice {
        margin: 18px 0 22px;
        padding: 13px 14px;
        border-left: 3px solid #19B5B0;
        background: rgba(25,181,176,.07);
        color: #c7d2df;
        line-height: 1.55;
        font-size: 14px;
      }

      .cvn-approve-actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        border-top: 1px solid #26354c;
        padding-top: 20px;
      }

      .cvn-approve-actions button {
        border-radius: 8px;
        padding: 11px 18px;
        font-weight: 700;
        cursor: pointer;
      }

      #cvnApproveCancel {
        background: transparent;
        border: 1px solid #536178;
        color: #ffffff;
      }

      #cvnApproveSubmit {
        background: #19B5B0;
        border: 1px solid #19B5B0;
        color: #07101f;
      }

      #cvnApproveSubmit:disabled {
        opacity: .55;
        cursor: not-allowed;
      }

      .cvn-approve-empty {
        padding: 18px;
        border: 1px solid #31415a;
        border-radius: 9px;
        color: #aab6c9;
      }

      @media (max-width: 700px) {
        .cvn-approve-grid {
          grid-template-columns: 1fr;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function closeModal() {
    document.getElementById('cvnApproveOverlay')?.remove();
  }

  function showMessage(message, type) {
    const el = document.getElementById('cvnApproveMessage');
    if (!el) return;

    el.className = type;
    el.textContent = message;
  }

  async function refreshAdminRegister() {
    const adminOverlay = document.getElementById('cvnAdminDocsOverlay');

    if (!adminOverlay) return;

    const refreshButton = Array.from(
      adminOverlay.querySelectorAll('button')
    ).find(
      (button) => button.textContent.trim() === 'Refresh Register'
    );

    if (refreshButton) {
      setTimeout(() => refreshButton.click(), 300);
    }
  }

  async function openApproveModal() {
    if (document.getElementById('cvnApproveOverlay')) return;

    const overlay = document.createElement('div');
    overlay.id = 'cvnApproveOverlay';

    overlay.innerHTML = `
      <div id="cvnApprovePanel">
        <h2>Approve Controlled Document</h2>

        <div class="cvn-approve-subtitle">
          Select an under-review version and establish its controlled effective
          and review dates.
        </div>

        <div id="cvnApproveMessage"></div>

        <div id="cvnApproveContent">
          Loading documents awaiting approval...
        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    try {
      const register = await rpc(
        'get_admin_controlled_document_register',
        {}
      );

      if (!Array.isArray(register)) {
        throw new Error('The controlled-document register could not be loaded.');
      }

      const underReview = register.filter(
        (row) =>
          String(row.version_status || '').toLowerCase() === 'under_review'
      );

      const content = document.getElementById('cvnApproveContent');

      if (!underReview.length) {
        content.innerHTML = `
          <div class="cvn-approve-empty">
            No controlled-document versions are currently awaiting approval.
          </div>

          <div class="cvn-approve-actions">
            <button id="cvnApproveCancel" type="button">Close</button>
          </div>
        `;

        document
          .getElementById('cvnApproveCancel')
          .addEventListener('click', closeModal);

        return;
      }

      const options = underReview
        .map((row, index) => {
          const code = escapeHtml(row.document_code);
          const title = escapeHtml(row.title);
          const version = escapeHtml(row.version_number);

          return `
            <option value="${index}">
              ${code} — ${title} — Version ${version}
            </option>
          `;
        })
        .join('');

      content.innerHTML = `
        <div class="cvn-approve-field">
          <label for="cvnApproveSelect">Document Awaiting Approval *</label>
          <select id="cvnApproveSelect">
            ${options}
          </select>
        </div>

        <div class="cvn-approve-grid">
          <div class="cvn-approve-field">
            <label for="cvnEffectiveDate">Effective Date *</label>
            <input id="cvnEffectiveDate" type="date" required>
          </div>

          <div class="cvn-approve-field">
            <label for="cvnReviewDueDate">Review Due Date *</label>
            <input id="cvnReviewDueDate" type="date" required>
          </div>
        </div>

        <div class="cvn-approve-notice">
          Approval makes this version an approved controlled document.
          The approving administrator and approval timestamp are recorded
          automatically by the protected backend workflow.
        </div>

        <div class="cvn-approve-actions">
          <button id="cvnApproveCancel" type="button">Cancel</button>
          <button id="cvnApproveSubmit" type="button">Approve Document</button>
        </div>
      `;

      document
        .getElementById('cvnApproveCancel')
        .addEventListener('click', closeModal);

      document
        .getElementById('cvnApproveSubmit')
        .addEventListener('click', async function () {
          const button = this;

          const selectedIndex = Number(
            document.getElementById('cvnApproveSelect').value
          );

          const selectedRow = underReview[selectedIndex];

          if (!selectedRow) {
            showMessage(
              'Please select a valid document awaiting approval.',
              'error'
            );
            return;
          }

          const effectiveDate =
            document.getElementById('cvnEffectiveDate').value;

          const reviewDueDate =
            document.getElementById('cvnReviewDueDate').value;

          if (!effectiveDate || !reviewDueDate) {
            showMessage(
              'Effective Date and Review Due Date are required.',
              'error'
            );
            return;
          }

          if (reviewDueDate < effectiveDate) {
            showMessage(
              'Review Due Date cannot be earlier than the Effective Date.',
              'error'
            );
            return;
          }

          const code = selectedRow.document_code;
          const version = selectedRow.version_number;

          button.disabled = true;
          button.textContent = 'Approving...';

          try {
            const versionId = await resolveVersionId(selectedRow);

            const result = await rpc(
              'approve_controlled_document_version',
              {
                p_document_version_id: versionId,
                p_effective_date: effectiveDate,
                p_review_due_date: reviewDueDate
              }
            );

            console.log(
              '[Corevian Admin Approve] Document approved:',
              result
            );

            showMessage(
              `${code} Version ${version} was approved successfully.`,
              'success'
            );

            await refreshAdminRegister();

            setTimeout(closeModal, 1400);

          } catch (error) {
            console.error(
              '[Corevian Admin Approve] Approval failed:',
              error
            );

            showMessage(
              error.message || 'Unable to approve this document.',
              'error'
            );

            button.disabled = false;
            button.textContent = 'Approve Document';
          }
        });

    } catch (error) {
      console.error(
        '[Corevian Admin Approve] Unable to load approval queue:',
        error
      );

      const content = document.getElementById('cvnApproveContent');

      content.innerHTML = `
        <div class="cvn-approve-empty">
          Unable to load documents awaiting approval.
        </div>

        <div class="cvn-approve-actions">
          <button id="cvnApproveCancel" type="button">Close</button>
        </div>
      `;

      showMessage(error.message, 'error');

      document
        .getElementById('cvnApproveCancel')
        .addEventListener('click', closeModal);
    }
  }

  function installLauncher() {
    const adminOverlay = document.getElementById('cvnAdminDocsOverlay');

    if (!adminOverlay) return false;

    if (document.getElementById('cvnApproveLauncher')) {
      return true;
    }

    const reviewButton =
      document.getElementById('cvnSubmitReviewLauncher');

    const createButton =
      document.getElementById('cvnCreateDraftBtn');

    const refreshButton = Array.from(
      adminOverlay.querySelectorAll('button')
    ).find(
      (button) => button.textContent.trim() === 'Refresh Register'
    );

    const anchor =
      reviewButton ||
      createButton ||
      refreshButton;

    if (!anchor) return false;

    const button = document.createElement('button');

    button.id = 'cvnApproveLauncher';
    button.type = 'button';
    button.textContent = 'Approve Document';

    anchor.insertAdjacentElement('afterend', button);

    button.addEventListener('click', openApproveModal);

    return true;
  }

  function start() {
    injectStyles();
    installLauncher();

    const observer = new MutationObserver(function () {
      installLauncher();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();